var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.permisoAccion.visible
    ? _c(
        "v-btn",
        {
          staticClass: "btn-crear",
          attrs: { "data-testid": "CrearButton" },
          on: {
            click: function($event) {
              return _vm.handleClick()
            }
          }
        },
        [
          _c("v-icon", { attrs: { dark: "", left: "" } }, [
            _vm._v("add_circle_outline")
          ]),
          _c("span", [_vm._v("Crear")])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }